import React from 'react';
import { CurrencyFormat } from '@lt/components';
import { HotPriceIcon } from './style';

const baseCls = 'checkout-billinfo';

interface HotPriceProps {
  value?: number;
  discount: boolean;
}

const HotPrice = ({ value, discount }: HotPriceProps) => {
  if (!discount || !value) return null;

  return (
    <div className={`${baseCls}__discount`}>
      <HotPriceIcon />
      <CurrencyFormat className={`${baseCls}__discount__value`} value={value} />
    </div>
  );
};

export default HotPrice;
